/**
 * 其他方法集
 * */
export default {
    // 数组和对象的存储需解析  needParse
    setSessionStorage (key, val, type = 'noParse') {
        if (type == 'needParse') {
            sessionStorage.setItem(key, JSON.stringify(val))
        } else {
            sessionStorage.setItem(key, val)
        }
    },
    // 数组和对象取出后需解析  needParse
    getSessionStorage (key, type = 'noParse') {
        if (type == 'needParse') {
            return JSON.parse(sessionStorage.getItem(key))
        }
        return sessionStorage.getItem(key)
    },
    getImageSize (file) {
        return new Promise(function (resolve, reject) {
            var reader = new FileReader()
            reader.onload = function (event) {
                var size = {size: Math.round(event.total / 1024)}
                var image = new Image()
                image.addEventListener('load', function ($event) {
                    var img = $event.target
                    size.w = img.width
                    size.h = img.height
                    resolve(size)
                })
                image.src = event.target.result
            }
            reader.readAsDataURL(file)
        })
    },
    // 从链接获取参数
    getParamFromUrlByKey (key) {
        return decodeURIComponent((new RegExp('[?|&]' + key + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [''])[1].replace(/\+/g, '%20')) || null
    },
    windowsJump (url, params) { // 页面跳转封装，1跳转， 2新窗口打开
        if (params && params.type == 2) {
            window.open(url, params.name || '', params.param || '')
        } else {
            window.location.href = url
        }
    },
    deepCopy (data) {
        const t = (typeof data)
        let o

        if (data && t === 'object') {
            o = (data.constructor == Array) ? [] : {}
        } else {
            return data
        }

        if (data.constructor == Array) {
            for (let i = 0, j = data.length; i < j; i++) {
                o.push(this.deepCopy(data[i]))
            }
        } else if (t === 'object') {
            for (let i in data) {
                o[i] = this.deepCopy(data[i])
            }
        }
        return o
    },
    alipayVersion () {
        let t = navigator.userAgent.match(/AlipayClient\/(.*)/)
        let alipayVersion = t && t.length ? t[1] : ''
        return alipayVersion.split('.')
    },
    browser: {
        versions () {
            let u = navigator.userAgent
            let app = navigator.appVersion

            return {
                trident: u.indexOf('Trident') > -1, //  IE内核
                presto: u.indexOf('Presto') > -1, //    opera内核
                webKit: u.indexOf('AppleWebKit') > -1, //   苹果、谷歌内核
                gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //  火狐内核
                mobile: !!u.match(/AppleWebKit.*Mobile.*/), //  是否为移动终端
                ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
                android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //   android终端或者uc浏览器
                iPhone: u.indexOf('iPhone') > -1, //    是否为iPhone或者QQHD浏览器
                iPad: u.indexOf('iPad') > -1, //    是否iPad
                webApp: u.indexOf('Safari') == -1, //   是否web应该程序，没有头部与底部
                weixin: u.indexOf('MicroMessenger') > -1, //    是否微信 （2015-01-22新增）
                qq: u.match(/\sQQ/i) == ' qq' //    是否QQ
            }
        },
        // language: (navigator.browserLanguage || navigator.language).toLowerCase()
    },
    toCamelCase (str) { //驼峰法
        let res = ''
        let strs = str.split('-')
        for (let item of strs) {
            res += item.charAt(0).toUpperCase() + item.substring(1)
        }
        return res
    }
}
